<template>
  <BModal
    id="modal-edit-organization"
    centered
    no-close-on-backdrop
    hide-footer
    hide-header
    size="md"
    @hidden="resetForm"
  >
    <div class="py-2 px-1">
      <!-- Header -->
      <div class="flex items-center justify-between mb-1">
        <h5 class="text-black text-[20px] font-semibold mb-0">
          Edit nama organisasi
        </h5>
        <button
          class="btn p-0"
          @click="$bvModal.hide('modal-edit-organization')"
        >
          <feather-icon
            icon="XIcon"
            size="20"
            class="text-[#6B7280]"
          />
        </button>
      </div>

      <!-- Subtitle -->
      <p class="text-[#6B7280] text-[14px] mb-1">
        Perbarui nama organisasi
      </p>

      <!-- Nama Organisasi -->
      <div class="mb-2">
        <label class="text-black font-medium text-[14px] mb-1 block">
          Nama organisasi<span class="text-[#F95031]">*</span>
        </label>
        <b-form-input
          v-model="organizationName"
          placeholder="Contoh : Komship connect"
          class="!rounded-lg"
          :class="{ '!border-[#F95031]': (isOrganizationNameDirty && organizationNameError !== '') || showMaxInputWarning || existNameOrg }"
          :maxlength="50"
          @input="isOrganizationNameDirty = true"
          @blur="isOrganizationNameDirty = true"
          @keydown="handleKeyDownOrganizationName"
        />
        <div
          v-if="isOrganizationNameDirty && organizationNameError !== ''"
          class="text-[#F95031] text-[12px] mt-1"
        >
          {{ organizationNameError }}
        </div>
        <div
          v-else-if="showMaxInputWarning"
          class="text-[#F95031] text-[12px] mt-1"
        >
          Maksimal 50 karakter
        </div>
        <div
          v-else-if="existNameOrg"
          class="text-[#F95031] text-[12px] mt-1"
        >
          Nama organisasi sudah digunakan
        </div>
      </div>

      <!-- Footer Buttons -->
      <div class="flex items-center justify-end gap-2 pt-2">
        <b-button
          variant="outline-secondary"
          class="!rounded-lg !px-6 !py-2 !border-[#E5E5E5] !text-black"
          @click="$bvModal.hide('modal-edit-organization')"
        >
          Batal
        </b-button>
        <b-button
          :variant="isFormValid ? 'primary' : 'secondary'"
          :disabled="!isFormValid || isSubmitting"
          class="!rounded-lg !px-6 !py-2"
          :class="{ '!bg-[#F95031] !border-[#F95031]': isFormValid }"
          @click="handleSubmit"
        >
          <b-spinner
            v-if="isSubmitting"
            small
            class="mr-1"
          />
          Simpan
        </b-button>
      </div>
    </div>
  </BModal>
</template>

<script>
import { newAxiosIns } from '@/libs/axios'
import { ignoredKeys } from './config'

export default {
  props: {
    initialData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      organizationName: '',
      isOrganizationNameDirty: false,
      isSubmitting: false,
      showMaxInputWarning: false,
      existNameOrg: false,
      lastExistOrgName: '',
    }
  },
  computed: {
    organizationNameError() {
      const len = this.organizationName.trim().length
      if (len === 0) return 'Field tidak boleh kosong'
      if (len < 2) return 'Minimal 2 karakter'
      if (len > 50) return 'Maksimal 50 karakter'
      return ''
    },
    isFormValid() {
      return this.organizationNameError === ''
    },
  },
  watch: {
    initialData: {
      handler(newVal) {
        if (newVal && newVal.name) {
          this.organizationName = newVal.name
        }
      },
      deep: true,
      immediate: true,
    },
    organizationName(newVal) {
      if (newVal.length < 50) {
        this.showMaxInputWarning = false
      }
      if (this.existNameOrg && newVal !== this.lastExistOrgName) {
        this.existNameOrg = false
      }
    },
  },
  methods: {
    handleKeyDownOrganizationName(event) {
      if (this.organizationName.length >= 50) {
        if (!ignoredKeys.includes(event.key) && !event.ctrlKey && !event.metaKey && !event.altKey) {
          this.showMaxInputWarning = true
        }
      }
    },
    resetForm() {
      this.organizationName = this.initialData ? this.initialData.name || '' : ''
      this.isOrganizationNameDirty = false
      this.showMaxInputWarning = false
      this.isSubmitting = false
      this.existNameOrg = false
      this.lastExistOrgName = ''
    },
    handleSubmit() {
      if (!this.isFormValid) return
      this.isSubmitting = true
      const url = '/auth/api/v1/organizations'

      const payload = {
        name: this.organizationName,
        id_org: this.initialData.id_org,
      }

      newAxiosIns
        .put(url, payload)
        .then(() => {
          this.$emit('submit', {
            url,
            payload,
          })
        })
        .catch(err => {
          const message = err?.response?.data?.meta?.message
          if (message && typeof message === 'string') {
            if (message.toLowerCase().includes('already exists')) {
              this.existNameOrg = true
              this.lastExistOrgName = this.organizationName
            }
            const capitalize = message.charAt(0).toUpperCase() + message.slice(1)
            this.$toast_error({ message: capitalize })
          } else if (err?.message) {
            this.$toast_error({ message: err.message })
          }
        })
        .finally(() => {
          this.isSubmitting = false
        })
    },
  },
}
</script>

<style scoped>

</style>
